import React from 'react';

function ConversationList({ conversations, selectedId, onSelect, loading }) {
  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        Chargement...
      </div>
    );
  }

  if (conversations.length === 0) {
    return (
      <div className="empty-state" style={{ padding: '40px 20px' }}>
        <p>Aucune conversation</p>
      </div>
    );
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const diff = now - date;

    // Moins d'une heure
    if (diff < 3600000) {
      const mins = Math.floor(diff / 60000);
      return `${mins}m`;
    }
    // Moins d'un jour
    if (diff < 86400000) {
      const hours = Math.floor(diff / 3600000);
      return `${hours}h`;
    }
    // Cette semaine
    if (diff < 604800000) {
      const days = Math.floor(diff / 86400000);
      return `${days}j`;
    }
    // Plus ancien
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' });
  };

  const truncate = (str, length) => {
    if (!str) return '';
    // Supprimer les balises HTML si présentes
    const text = str.replace(/<[^>]*>/g, '');
    return text.length > length ? text.substring(0, length) + '...' : text;
  };

  const getStatusColor = (status) => {
    if (!status) return 'var(--text-muted)';
    const s = status.toLowerCase();
    if (s.includes('nouveau') || s.includes('new')) return '#3b82f6';
    if (s.includes('en cours') || s.includes('progress') || s.includes('traitement')) return '#f59e0b';
    if (s.includes('résolu') || s.includes('resolu') || s.includes('done') || s.includes('terminé')) return '#22c55e';
    if (s.includes('annulé') || s.includes('cancelled')) return '#ef4444';
    if (s.includes('attente') || s.includes('waiting') || s.includes('pending')) return '#8b5cf6';
    return 'var(--text-muted)';
  };

  return (
    <div className="conversation-list">
      {conversations.map(conv => (
        <div
          key={conv.id}
          className={`conversation-item ${selectedId === conv.id ? 'active' : ''} ${conv.unread ? 'unread' : ''}`}
          onClick={() => onSelect(conv)}
        >
          {conv.unread && <div className="unread-badge"></div>}

          <div className="conversation-header">
            <span className={`conversation-source ${conv.source}`}>
              {conv.source === 'odoo' ? 'Odoo' : 'WA'}
            </span>
            {conv.source === 'whatsapp' && conv.instanceName && (
              <span style={{
                fontSize: '0.6rem',
                padding: '1px 5px',
                borderRadius: '6px',
                background: 'rgba(37, 211, 102, 0.15)',
                color: '#25d366',
                fontWeight: '500',
                marginLeft: '5px'
              }}>
                {conv.instanceName}
              </span>
            )}
            {((conv.source === 'odoo' && conv.customer) || (conv.source === 'whatsapp' && conv.partnerName)) && (
              <span style={{
                fontSize: '0.6rem',
                padding: '1px 5px',
                borderRadius: '6px',
                background: conv.source === 'odoo' ? 'rgba(124, 58, 237, 0.15)' : 'rgba(37, 211, 102, 0.15)',
                color: conv.source === 'odoo' ? '#7c3aed' : '#25d366',
                fontWeight: '500',
                marginLeft: '5px',
                maxWidth: '120px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>
                {conv.source === 'odoo' ? conv.customer : conv.partnerName}
              </span>
            )}
            {conv.status && (
              <span style={{
                fontSize: '0.65rem',
                padding: '2px 6px',
                borderRadius: '8px',
                background: getStatusColor(conv.status),
                color: 'white',
                fontWeight: '600',
                marginLeft: 'auto'
              }}>
                {conv.status}
              </span>
            )}
          </div>

          <div className="conversation-title">
            {conv.source === 'odoo' ? conv.title : (() => {
              if (conv.partnerId && conv.partnerName) {
                const name = conv.contactFirstname
                  ? `${conv.partnerName} ${conv.contactFirstname.toUpperCase()}`
                  : conv.partnerName;
                return name;
              }
              return conv.customer;
            })()}
          </div>

          <div className="conversation-preview">
            {conv.source === 'odoo' && conv.customer && (
              <span style={{ color: 'var(--accent)', marginRight: '5px' }}>
                {conv.customer}:
              </span>
            )}
            {truncate(conv.lastMessage, 40)}
          </div>

          <div className="conversation-meta">
            <span>{conv.assignedTo || 'Non assigné'}</span>
            <span>{formatDate(conv.updatedAt)}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ConversationList;
